import { z } from "zod";
import { CheckboxFilterTypeSchema, MustMatchAnyMatchNoneSchema } from "../common/common-filter-definitions-schema";

// --- Checkbox Filter (with values) ---
export const USCheckboxValueSchema = z.object({
  key: z.string(),
  checked: z.boolean().optional(),
});

export const USCheckboxFilterSchema = z.object({
  id: z.string(),
  values: z.array(USCheckboxValueSchema),
  must: MustMatchAnyMatchNoneSchema,
  type: CheckboxFilterTypeSchema,
});
